export const checkMark = '\u2713';
export const xMark = '\u2717';
export const READINESS_CHECK_TOOLTIP = 'The backend performs synchronous readiness validation, including but not limited to schema, cluster duplication, ECU catalog, cluster, and JFrog URL checks. No SRPd is submitted or published.';


export const errorText = {
    unexpectedError: "An unexpected error has occurred. Please contact the administrator.",
    alreadyCreated: "Request already created, please refresh to submit a new request.",
    alreadyInProgress: "Request already in progress, please wait.",
    alreadyExists: "SRP already exists in Jira Service Management",
    fileNotJSON: "Please submit a JSON file",
    parsingError: "There was an issue parsing the selected file",
    buildingError: "There was in issue building the JSON file",
    requiredFieldMissing: "Required field missing",
    schemaOutOfDate: ("The Schema of the selected SRP is out of date"),
    // Please update it using 'Edit Existing SRP' in the 'Manual Input' tab.</div>),
    fetchingSchema: "Latest SRP Schema is still being fetched, please wait a moment and try again",
    createFail: "Failed to create JSM request",
    attachFail: "Failed to attach JSON to JSM request",
    jfrogFail: "Failed to upload to JFROG",
    githubIntegrationFail: "Failed to execute Github Integration",
    extraContentFail: "Failed to upload extra SRP content",
    architectureTypeFail: "Unsupported electrical architecture",
};

export const prefillValidationErrorMessages = {
    "name":"Missing field 'SRP Name'.",
    "machineList":"Missing section 'Machine List'.",
    "version":"Missing field 'Version'.",
    "srpSchemaVersion":"Missing field 'SRP Schema Version'."

};

export const currentSRPSchemaVersion = "0.1.1";

export const JFROG_API_SRP_JSON_REPO_NAME = "jnmo-srp-raw-local";

export const JFROG_API_SRP_JSON_REPO_URL = `https://jfrog.ford.com/ui/repos/tree/General/${JFROG_API_SRP_JSON_REPO_NAME}`;


export const REQUIRED_COMPONENT_ID = "customfield_16484";
export const SUPPLIER_ID = "customfield_10706";
export const TRADITIONAL_SIGNING_ID = "SIGNING_ID_TRADITIONAL";


export const FNV3X_ARCHITECTURES = ["FNV3.2", "FNV3.4"];
export const FNV23_ARCHITECTURES = ["FNV2", "FNV3"];
export const UI_SUPPORTED_ARCHITECTURES = [...FNV3X_ARCHITECTURES, ...FNV23_ARCHITECTURES];
